// IMPORTANT: MATCH THE ACTION TYPE!!!!!!!!!!
import { reduce as UPDATE_ENTITY } from './update-entity';
import { reduce as CREATE_ENTITY } from './create-entity';
import { reduce as INIT_REMOTE_DATA } from './init-remote-data';
import { reduce as SET_REMOTE_DATA } from './set-remote-data';
import { reduce as CLEAR_REMOTE_DATA } from './clear-remote-data';
import { reduce as FETCHING_REMOTE_DATA } from './fetching-remote-data';
import { reduce as ERROR_IN_REMOTE_DATA } from './error-in-remote-data';
import { reduce as INVALIDATE_ENTITY } from './invalidate-entity';
import { reduce as CONNECTION_OFFLINE } from './connection-offline';
import { reduce as CONNECTION_ONLINE } from './connection-online';
import { reduce as EMPTY_CONTEXT } from './empty-context';
import { reduce as PARTIAL_UPDATE_ENTITY } from './partial-update-entity';
import { reduce as PARTIAL_CREATE_ENTITY } from './partial-create-entity';
import { reduce as INVALIDATE_ALL } from './invalidate-all';

const reducers = {
  UPDATE_ENTITY,
  CREATE_ENTITY,
  INIT_REMOTE_DATA,
  SET_REMOTE_DATA,
  CLEAR_REMOTE_DATA,
  FETCHING_REMOTE_DATA,
  ERROR_IN_REMOTE_DATA,
  INVALIDATE_ENTITY,
  CONNECTION_OFFLINE,
  CONNECTION_ONLINE,
  EMPTY_CONTEXT,
  PARTIAL_UPDATE_ENTITY,
  PARTIAL_CREATE_ENTITY,
  INVALIDATE_ALL,
};

export default reducers;
